import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@cargomatic/ui';
import DocumentPreview from 'components/modules/shipments/stops/DocumentPreview';
import { sluggify } from 'utils/localization/utils';

export default function UploadedDocumentPreviewModal({ name, url, onHide }) {
  const { t } = useTranslation();
  const [paginationContainer, setPaginationContainer] = useState(null);

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onHide();
      }}
    >
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{t(sluggify(name))}</DialogTitle>
        </DialogHeader>
        <div className="flex w-full">
          <div className="mx-auto">
            <DocumentPreview
              height="100%"
              width="100%"
              url={url}
              paginationContainer={paginationContainer}
            />
          </div>
        </div>
        <DialogFooter className="sm:justify-between">
          <div ref={setPaginationContainer} className="flex flex-1" />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
